import React, { useEffect, useContext, useState, useActionState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Card from '../ERUMAUI/UI_Card';
import Panel_Map_Left from '../InteractiveMap/Panel_Map_Left';
import Panel_Map_Center from '../InteractiveMap/Panel_Map_Center';
import UI_Icon from '../ERUMAUI/UI_Icons';

export default function Subwindow_ScheduleManagement_Map({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Template_List } = useTemplating();
    const { Information_Display, Map_Information, Map_Information_Type } = useMapRenderer();
    const { Reservation, Reservation_Set } = useScheduleManagement();
    const Close = () => {
        UI.Subwindows_Close(id);
    }

    const Handle_Use = () => {
        if (!Map_Information || Map_Information_Type !== "Room") return;

        Reservation_Set(prev => ({
            ...prev,
            RoomID: Map_Information._id
        }));

        // SyncDropdownsFromRoom(Map_Information);
        Close();
    };

    


    return (
        <ui-subwindow Type='Subwindow' Fullscreen="Fullscreen" id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Choose from the map
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "500px" }}>
                <div className='SM_Map'>
                    <div className='SM_Map_Directory'>
                        <Panel_Map_Left />
                    </div>
                    <div className='SM_Map_Main'>
                        <Panel_Map_Center />
                    </div>
                    <div className='SM_Map_Selection'>
                        {Map_Information_Type == "Room" ?
                            <>
                                <div>
                                    <h2 className='General_Title'>
                                        {Map_Information.Name}
                                    </h2>
                                    <UI_Card Type="Panel_Info" Text="Room code" Figure={Map_Information.Location?.Code} />
                                </div>
                                <UI_Button
                                    Text="Use this room"
                                    Icon={<UI_Icon Name="Map" />}
                                    Icon_Position="Left"
                                    OnClick={ Handle_Use } />
                            </>
                            :
                            <>
                                <p className='General_Paragraph'>
                                    Please select a room to use for your reservation.
                                </p>
                            </>
                        }


                        {/* <h2 className='General_Paragraph'>
                            {Map_Information.Location?.Code}
                        </h2> */}
                    </div>

                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                {/* <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                    Close
                </button> */}
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
